import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import styles from "./ImportTemplateModal.module.css";
import { IoIosClose } from "react-icons/io";
import { connect, useDispatch } from "react-redux";
import {themeColors} from "../../theme";
import { motion,AnimatePresence } from "framer-motion";
import Backdrop from "../../Backdrop/Backdrop";
import Label from "../../Label";
import Dropdown from "../../DropDown/Dropdown";
import Select from "react-select";
import makeAnimated from "react-select/animated";


type props = {
  open: boolean;
  close: () => void;
  heading: string;
  title: string;
  onSave: (value: any,textareaValue:any) => void;
  theme:any;
  name1:any;
  detail:any;
};

const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 1,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
};

const EditTemplateModal: FunctionComponent<props> = ({
  open,
  close,
  heading,
  title,
  onSave,
  theme,
  name1,
  detail
}) => {
  const [value, setValue] = useState(name1);
  const [templateName,setTemplateName] = useState(name1)
  const animatedComponents = makeAnimated();
  const containerStyles ={ backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark} 
  const [textareaValue, setTextareaValue] = useState(detail);
  const option = ["Customer Name","Project Name","Lead Owner Name","Lead Owner Number","Follow Up Time","Project Address","Project Map Link","Lead Owner Email","Lead Number","Project Details"]
  const textareaRef = useRef<HTMLTextAreaElement>(null);

    const onClick = ((value1: any)=>{
      if (textareaRef.current) {
        const textarea = textareaRef.current;
        const startPos = textarea.selectionStart;
        const endPos = textarea.selectionEnd;
  
        const newValue = textareaValue.substring(0, startPos) + ` {{${value1}}} ` + textareaValue.substring(endPos);
  
        setTextareaValue(newValue);
        const newCursorPos = startPos + value1.length + 6;
  
        textarea.value = newValue;
        textarea.setSelectionRange(newCursorPos, newCursorPos);
        
        const scrollTop = textarea.scrollTop;
        textarea.focus();
        textarea.scrollTop = scrollTop;
      }
    })
    const handleTextareaChange = (event:React.ChangeEvent<HTMLTextAreaElement>) => {
      setTextareaValue(event.target.value);
    };
    const buttonsRows = [];
    for (let i = 0; i < option.length; i += 4) {
      const row = option.slice(i, i + 4);
      const rowButtons = row.map((buttonValue, index) => (
        <div className={`${styles.nameBox} button-column`}>
        <button className={`${styles.change} column-button`}
          key={index}
          onClick={() => onClick(buttonValue)}
        >
          {buttonValue}
        </button>
        </div>
      ));
      buttonsRows.push(
        <div key={i} className="button-row">
          {rowButtons}
        </div>
      );
    }
  return (

     <Backdrop>
      <motion.div
        key="modal"
        className="card p-4 shadow rounded"
        style={{position: "absolute",
        ...containerStyles}}
        variants={dropIn}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <div className={styles.headingContainer}>
      <h6 
      >{"Enter Template Name"}</h6>   
      </div>
      <input
          // className={styles.input}
          className="form-control"
          style={{  flex: 1,fontSize:"14px"}}
          placeholder={"Enter Template Name"}
          value={value?value:""}
          onChange={(event) => setValue(event.target.value)}
        />
      <div className={styles.headingContainer}>
      <h6 
      >{heading}</h6>      
      </div>
        <div className={styles.nameBox} style={{marginTop:"-0.5rem"}}>
      {buttonsRows}
      </div>
      <div className={styles.headingContainer}>
        {/* <span className={styles.name}>{title}</span> */}
        <h6>{title}:</h6>
  {/* <Select
        className={styles.select}
        menuPlacement="auto"
        maxMenuHeight={150}
        options={choice()}
        // value={selectedValue}
        components={animatedComponents}
        onChange={(data) =>{
        //   if (data?.label === title) {
        //     if (setDetails) setDetails();
        //   }
        //   setSelectedValue(data);
        }}
        showCheckbox={true}
        isSearchable={true}
        // isDisabled={disable ? true : choice().length === 0 ? true : false}
        // isMulti={isMulti}
        // style={style}
      /> */}
      </div>
      <div className={styles.nameBox}>
      {/* <textarea
          // className={styles.input}
          className="form-control"
          style={{  flex: 1,fontSize:"14px",height:"300px"}}
          placeholder={""}
          onChange={(event) => setValue(event.target.value)}
        /> */}
        <textarea
          // className={styles.input}
          className="form-control"
          // placeholder={"Enter Template Details"}
          style={{  flex: 1,fontSize:"14px",height:"250px"}}
          ref={textareaRef}
        value={textareaValue}
        onChange={handleTextareaChange}
        />
      </div>
      <div className={styles.button}>

      <button className={styles.saveBtn} onClick={() => {
        // console.log("GVBDFSGBDRFB",value)
        onSave(value,textareaValue)}}>
          Save
        </button>
        <button className={styles.cancelBtn} onClick={close}>
          Close
        </button>
      </div>
      </motion.div>
     </Backdrop>
  );
};



const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    contacts: state.contacts,
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(EditTemplateModal);
